import axios from "axios";
import { Dispatch } from "redux";
import { Vehicle } from "../types";
import { Action } from "./actions";
import { VehicleActions } from "./action_types";

export const create_vehicle = (vehicle: Vehicle) => {
  return (dispatch: Dispatch<Action>) => {

    dispatch({
      type: VehicleActions.CREATE_VEHICLE,
      payload: vehicle
    })
  }
}

export const update_vehicle = (vehicle: Vehicle) => {
  return async (dispatch: Dispatch<Action>) => {
    await axios.put(`/api/vehicles/${vehicle?.id}/`, vehicle)

    dispatch({
      type: VehicleActions.UPDATE_VEHICLE,
      payload: vehicle
    })
  }
}

const recentReprocessRequests = new Set<string>();

export const reprocessVehicle = async (pk: string, sk: string, target: string) => {
  const requestIdentifier = `${pk}-${target}`;

  if (recentReprocessRequests.has(requestIdentifier)) {
    console.log(`Reprocessing for ${requestIdentifier} was already requested within the last 30 seconds. Skipping.`);
    return;
  }

  try {
    recentReprocessRequests.add(requestIdentifier);
    setTimeout(() => {
      recentReprocessRequests.delete(requestIdentifier);
    }, 30000);

    const url = `${process.env.REACT_APP_UMS_API_BASE_URL}/asset/reprocess`;
    const headers = {
      Authorization: 'bwenvdev'
    };

    console.log(`Requesting reprocessing for ${requestIdentifier}...`);
    await axios.post(url, { pk, sk, target }, { headers });

  } catch (error: any) {
    console.error("Error reprocessing vehicle", error);

    if (error.response && error.response.status === 423) {
      const assetId = pk.replace("asset#", '').split("-")[0];
      alert(`Vehicle ${assetId} is currently locked. Try again later.`);
    } else {
      alert("An error occurred while reprocessing the vehicle. Please check the console logs.");
    }
    recentReprocessRequests.delete(requestIdentifier);
  }
};
